import { Button, Card, Skeleton, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomTable from "../common/Table";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { ReceiptFilterSelect } from "./SharedComponent";

const { TabPane } = Tabs;

const HotelReceipts = () => {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const {
        selectedDates,
        setSelectedCheckinType,
        selectedCheckinType,
        selectedReceiptTab,
        setSelectedRecipetTab,
    } = useContext(SettingContext);

    const [start_date, end_date] = selectedDates;
    const { hotel_id } = useParams();
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState(selectedReceiptTab);
    const [filterValue, setFilterValue] = useState(selectedCheckinType);
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        hotel_ids: [hotel_id],
        hotel_type: "all",
        receipt_sent_via: activeTab === "mail" ? 1 : 2,
        transaction_via: filterValue,
    });

    const {
        status: hotelReceiptsStatus,
        data: hotelReceiptsRes,
        refetch: fetchHotelReceiptsDetails,
    } = useQuery(
        `receipts${hotel_id}`,
        async () => {
            return await HTTP(
                "/dashboard/getDashboardReceiptsWiseCountsForHotel",
                {
                    ...formData,
                },
            );
        },
        { enabled: false },
    );

    const formatSentMailData = (sentMailData) => {
        if (sentMailData && sentMailData.length > 0) {
            sentMailData.map((item) => {
                if (item.receipt_is_for === 1)
                    return (item.lable = "Cash Receipt");
                if (item.receipt_is_for === 2)
                    return (item.lable = "Room Receipt");
                if (item.receipt_is_for === 3)
                    return (item.lable = "Parking Pass");
                if (item.receipt_is_for === 4)
                    return (item.lable = "Key Code Receipt");
            });
        }
        setTableData(sentMailData);
    };

    useEffect(() => {
        fetchHotelReceiptsDetails();
    }, []);

    useEffect(() => {
        fetchHotelReceiptsDetails();
    }, [formData]);

    useEffect(() => {
        if (hotelReceiptsStatus === "success") {
            const { data: sentMailData, total } = hotelReceiptsRes;
            setTotalRecords(total);
            formatSentMailData(sentMailData);
        }
    }, [hotelReceiptsStatus, hotelReceiptsRes]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        const receipt_sent_via = activeTab === "mail" ? 1 : 2;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
            receipt_sent_via,
            transaction_via: Number(filterValue),
        });
    }, [selectedDates, activeTab, filterValue]);

    const handleReceiptClick = (e) => {
        const receipt_is_for = e.currentTarget.getAttribute("id");
        return navigate(`/sent_receipt/${hotel_id}/${receipt_is_for}`, {
            state: {
                receipt_sent_via: formData.receipt_sent_via,
                transaction_via: filterValue,
            },
        });
    };

    const columns = [
        {
            title: activeTab === "mail" ? "Mails" : "Prints",
            dataIndex: "lable",
            render: (text, record) => (
                <span
                    onClick={handleReceiptClick}
                    id={record.receipt_is_for}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Count",
            dataIndex: "count",
            key: "count",
        },
    ];

    function handleTableChange(pagination) {
        const { current } = pagination;
        setCurrentPage(current);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        const res = await HTTP(
            "/dashboard/getDashboardReceiptsWiseCountsForHotelReport",
            {
                ...tempFormData,
            },
        );
        downloadCSV(res, `Hotel_sent_receipt_report`);
    }

    const handleFilterChange = (e) => {
        setSelectedCheckinType(e);
        setFilterValue(e);
    };

    const TableComponentForMailAndPrint = ({ receiptStatus }) => {
        return (
            <>
                {receiptStatus === "loading" && receiptStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        currentPage={currentPage}
                        handleTableChange={handleTableChange}
                        rowKey="id"
                    />
                )}
            </>
        );
    };

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <ReceiptFilterSelect
                handleSelectChange={handleFilterChange}
                filterValue={filterValue}
            />
            <Tabs
                type="card"
                destroyInactiveTabPane={true}
                activeKey={activeTab}
                onChange={(key) => {
                    setActiveTab(key);
                    setSelectedRecipetTab(key);
                }}
            >
                <TabPane key="mail" tab="Mails">
                    <TableComponentForMailAndPrint
                        receiptStatus={hotelReceiptsStatus}
                    />
                </TabPane>
                <TabPane key="print" tab="Prints">
                    <TableComponentForMailAndPrint
                        receiptStatus={hotelReceiptsStatus}
                    />
                </TabPane>
            </Tabs>
        </Card>
    );
};

export default HotelReceipts;
